import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-400" }, "Valores", -1)
const _hoisted_3 = { class: "space-y-3 text-sm text-slate-600" }
const _hoisted_4 = { class: "flex justify-between gap-4" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Entrega em", -1)
const _hoisted_6 = { class: "text-right text-slate-950" }
const _hoisted_7 = { class: "flex justify-between gap-4" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "Previsão", -1)
const _hoisted_9 = { class: "text-slate-950" }
const _hoisted_10 = { class: "flex justify-between gap-4" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", null, "Produtos", -1)
const _hoisted_12 = { class: "text-slate-950" }
const _hoisted_13 = { class: "flex justify-between gap-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "Frete", -1)
const _hoisted_15 = { class: "text-slate-950" }
const _hoisted_16 = { class: "mt-4 flex justify-between border-t border-slate-200 pt-4 text-lg font-bold text-slate-950" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", null, "Total", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createElementVNode("strong", _hoisted_6, _toDisplayString(_ctx.destination || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("strong", _hoisted_9, _toDisplayString(_ctx.prompt > 0 ? `${_ctx.prompt} dias úteis` : '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _hoisted_11,
        _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.formatCurrency(_ctx.productsValue)), 1)
      ]),
      _createElementVNode("div", _hoisted_13, [
        _hoisted_14,
        _createElementVNode("strong", _hoisted_15, _toDisplayString(_ctx.formatCurrency(_ctx.freightValue)), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _hoisted_17,
      _createElementVNode("span", null, _toDisplayString(_ctx.formatCurrency(_ctx.totalValue)), 1)
    ])
  ]))
}